export default function validation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const errorMessage = error.message;
    if (errorMessage && errorMessage.indexOf('START_DATE_GREATER_THAN_END_DATE') === 0) {
      messages.push({
        message: 'addExerciceComptable.error.dateDebutGreaterdateFin',
      });
    }
    const errors = error.members;
    if (errors && errors.indexOf('dateDebut') === 0) {
      messages.push({
        message: 'addExerciceComptable.error.dateDebut',
      });
    }
    if (errors && errors.indexOf('dateFin') === 0) {
      messages.push({
        message: 'addExerciceComptable.error.dateFin',
      });
    }
    if (errors && errors.indexOf('code') === 0) {
      messages.push({
        message: 'addExerciceComptable.error.code',
      });
    }
  });
}
